import { Box, Divider, Flex, Paper, Text } from '../../styles';
import Avatar from '../../styles/Avatar';
import { Comment } from '../../apiService';
import { ComponentProps } from 'react';
// import { Comment, CommentReactionResponse, postCommentReaction } from './apiService';
// import { ComponentProps, useState } from 'react';
// import { DislikeButton, LikeButton } from './Reaction';
// import AlertService from './AlertService';
// import { getAxiosError } from './utils';
// import { AxiosError } from 'axios';
// import { useUser } from './CacheProvider';
// import { useRouter } from 'next/router';

export default function CommentItem(props: CommentItemProps) {
  return (
    <Flex as={Paper} direction="column" p={3} mt={2}>
      <CommentHeader {...props} />
      <Divider mb={1} mt={{ md: 2 }} mr={rightColSize} />
      <CommentBody {...props} />
    </Flex>
  );
}

const CommentHeader = ({ user }: CommentHeaderProps) => (
  <Flex justify="space-between">
    <Commenter user={user} />
    {/* <Reactions {...rest} /> */}
  </Flex>
);

// const Reactions = ({ id, contentId, like_count, dislike_count }: ReactionProps) => {
//   const { asPath: redirect, push } = useRouter();
//   const { authorized, loaded } = useUser();
//   const [{ like_count: likes, dislike_count: dislikes, comment_interaction: reaction }, setState] = useState<CommentReactionResponse>({
//     comment_interaction: 'none',
//     dislike_count,
//     like_count,
//   });
//   const [loading, setLoading] = useState(false);

//   const handleSuccess = ({ data }: { data: CommentReactionResponse }) => {
//     setLoading(false);
//     setState(data);
//   };

//   const handleError = (e: AxiosError) => {
//     setLoading(false);
//     AlertService.info(getAxiosError(e));
//   };

//   const handleClick: ComponentProps<typeof LikeButton>['onClick'] = (type) => {
//     if (!loaded || loading) return;
//     if (!authorized) return push(`/login?redirect=${redirect}`);

//     setLoading(true);
//     postCommentReaction({ type, id, contentId }).then(handleSuccess, handleError);
//   };

//   return (
//     <Flex>
//       <LikeButton
//         count={likes}
//         isLoading={loading}
//         active={reaction === 'like'}
//         onClick={handleClick}
//         inputSize="small"
//         ml={{ xs: 2, md: 5 }}
//       />
//       <DislikeButton
//         count={dislikes}
//         isLoading={loading}
//         active={reaction === 'dislike'}
//         onClick={handleClick}
//         inputSize="small"
//       />
//     </Flex>
//   );
// };

const Commenter = ({ user }: CommenterProps) => (
  <Flex align="center">
    <Avatar size={rem(avatarSize)} image={user.avatar} alt={user.name} />
    <Box mx={{ xs: 1, md: 2 }} dir='ltr'>
      {user.name} {user.family}
    </Box>
  </Flex>
);

const CommentBody = ({ text }: CommentBodyProps) => (
  <Text variant="body2" mr={rightColSize}>
    {text}
  </Text>
);

// ----- //
// UTILS //
// ----- //

const rem = (size: number) => `${size}rem`;
const avatarSize = 2.25;
const rightColSize: ComponentProps<typeof Divider>['m'] = {
  xs: rem(avatarSize + 0.5),
  md: rem(avatarSize + 0.75),
};

// ----- //
// TYPES //
// ----- //

type CommentItemProps = Comment & {
  contentId: string;
};

type CommentHeaderProps = CommentItemProps;
type CommenterProps = Pick<CommentItemProps, 'user'>;
type CommentBodyProps = Omit<CommentItemProps, 'contentId'>;
// type ReactionProps = Pick<CommentHeaderProps, 'contentId' | 'like_count' | 'dislike_count' | 'id'>;
